module.exports = __webpack_public_path__ + "static/img/CgoRC2ORiReAYZfFABD0skrb8iw857.64920bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2ORiReAYZfFABD0skrb8iw857.png
// module id = y1B1
// module chunks = 73